export default __webpack_public_path__ + "static/media/error404picture.56aedf34.jpg";